export const REEDIT_RECALL_MSG_TIME = 1000 * 60 * 2

export const SHOW_RECALL_BTN_MSG_TIME = 1000 * 60 * 2

export const MIN_VALUE = Number.MIN_VALUE

export const MAX_UPLOAD_FILE_SIZE = 100

// 对话框中要展示的文件icon标识
export const fileIconMap = {
  img: 'imicon-tupian2',
  pdf: 'imicon-PPT',
  word: 'imicon-Word',
  excel: 'imicon-Excel',
  ppt: 'imicon-PPT',
  audio: 'imicon-yinle',
  zip: 'imicon-RAR1',
  video: 'imicon-shipin',
  txt: 'imicon-qita',
}

export const AI_SEARCH_MENU_KEY = 'aiSearch'
